import { createRouteRef, createApiRef, createPlugin, createApiFactory, discoveryApiRef, identityApiRef, createRoutableExtension } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { stringifyEntityRef } from '@backstage/catalog-model';
import React from 'react';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import qs from 'qs';

const rootRouteRef = createRouteRef({
  id: "tech-insights"
});

const techInsightsApiRef = createApiRef({
  id: "plugin.techinsights.service"
});

const BooleanCheck = (props) => {
  return !!props.checkResult.result ? /* @__PURE__ */ React.createElement(CheckCircleOutline, { color: "primary" }) : /* @__PURE__ */ React.createElement(ErrorOutlineIcon, { color: "error" });
};

const jsonRulesEngineCheckResultRenderer = {
  type: "json-rules-engine",
  component: (checkResult) => /* @__PURE__ */ React.createElement(BooleanCheck, { checkResult })
};

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TechInsightsClient {
  constructor(options) {
    __publicField(this, "discoveryApi");
    __publicField(this, "identityApi");
    __publicField(this, "renderers");
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
    this.renderers = options.renderers;
  }
  async getFacts(entity, facts) {
    const query = qs.stringify({
      entity: stringifyEntityRef(entity),
      ids: facts
    });
    return await this.api(`/facts/latest?${query}`);
  }
  getCheckResultRenderers(types) {
    var _a;
    const renderers = (_a = this.renderers) != null ? _a : [jsonRulesEngineCheckResultRenderer];
    return renderers.filter((d) => types.includes(d.type));
  }
  async getAllChecks() {
    return this.api("/checks");
  }
  async getFactSchemas() {
    return this.api("/fact-schemas");
  }
  async runChecks(entityParams, checks) {
    const { namespace, kind, name } = entityParams;
    const requestBody = { checks };
    return this.api(
      `/checks/run/${encodeURIComponent(namespace)}/${encodeURIComponent(
        kind
      )}/${encodeURIComponent(name)}`,
      {
        method: "POST",
        body: JSON.stringify(requestBody)
      }
    );
  }
  async runBulkChecks(entities, checks) {
    const checkIds = checks ? checks.map((check) => check.id) : [];
    const requestBody = {
      entities,
      checks: checkIds.length > 0 ? checkIds : void 0
    };
    return this.api("/checks/run", {
      method: "POST",
      body: JSON.stringify(requestBody)
    });
  }
  async api(path, init) {
    const url = await this.discoveryApi.getBaseUrl("tech-insights");
    const { token } = await this.identityApi.getCredentials();
    const headers = new Headers(init == null ? void 0 : init.headers);
    if (!headers.has("content-type"))
      headers.set("content-type", "application/json");
    if (token && !headers.has("authorization")) {
      headers.set("authorization", `Bearer ${token}`);
    }
    const request = new Request(`${url}${path}`, {
      ...init,
      headers
    });
    return fetch(request).then(async (response) => {
      if (!response.ok) {
        throw await ResponseError.fromResponse(response);
      }
      return response.json();
    });
  }
}

const techInsightsPlugin = createPlugin({
  id: "tech-insights",
  apis: [
    createApiFactory({
      api: techInsightsApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) => new TechInsightsClient({ discoveryApi, identityApi })
    })
  ],
  routes: {
    root: rootRouteRef
  }
});
const EntityTechInsightsScorecardContent = techInsightsPlugin.provide(
  createRoutableExtension({
    name: "EntityTechInsightsScorecardContent",
    component: () => import('./esm/index-0014782a.esm.js').then((m) => m.ScorecardsContent),
    mountPoint: rootRouteRef
  })
);
const EntityTechInsightsScorecardCard = techInsightsPlugin.provide(
  createRoutableExtension({
    name: "EntityTechInsightsScorecardCard",
    component: () => import('./esm/index-1967aebb.esm.js').then((m) => m.ScorecardsCard),
    mountPoint: rootRouteRef
  })
);

export { BooleanCheck, EntityTechInsightsScorecardCard, EntityTechInsightsScorecardContent, TechInsightsClient, jsonRulesEngineCheckResultRenderer, techInsightsApiRef, techInsightsPlugin };
//# sourceMappingURL=index.esm.js.map
